import { createSlice } from "@reduxjs/toolkit";
export const KotGenerate = createSlice({
  name: "KOTGenerated",

  // Initial state: false means KOT is not yet generated
  initialState: {
    value: false,
  },
  reducers: {
    KotGenerated: (state) => {
      state.value = true;
    },
    KotNotGenerated: (state) => {
      state.value = false;
    },
  },
});

// Exporting actions for use in components or other slices
export const { KotGenerated, KotNotGenerated } = KotGenerate.actions;
export default KotGenerate.reducer;
